// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__nb8ca","logo":"styles_logo__CRF9T","description":"styles_description__ArDP7","welcome_text":"styles_welcome_text__iBXXb"};